import curry from 'lodash/curry';

import {
  defaultOccurrenceComparatorValues,
  defaultPurchaseComparatorValues,
  GOAL_TYPES,
  OCCURRENCE_CONDITION_QUERY_KEY,
  PURCHASE_CONDITION_QUERY_KEY,
} from '../constants';

export function createByEventType(compareType, creator, orQuery) {
  if (
    !compareType ||
    [GOAL_TYPES.customEvent, GOAL_TYPES.systemEvent, GOAL_TYPES.purchaseEvent].includes(compareType)
  ) {
    return creator(orQuery);
  }
  return null;
}

export function createByPurchaseType(compareType, creator, orQuery) {
  if ([GOAL_TYPES.purchaseEvent].includes(compareType)) {
    return creator(orQuery);
  }
  return null;
}

export function getConditionClauseByKey(key, orQuery) {
  const maybeMatchingCondition = orQuery.eventConditions?.find(
    (condition) => condition.queryKey === key,
  );
  return maybeMatchingCondition?.query || {};
}

export const baseEventCreator = curry((orQueryClause) => {
  let maybeExistingOccurrence =
    getConditionClauseByKey(OCCURRENCE_CONDITION_QUERY_KEY, orQueryClause) ||
    orQueryClause[OCCURRENCE_CONDITION_QUERY_KEY];

  // no type indicates a new query block, default comparator values for req for ux
  if (!orQueryClause.type) {
    return {
      queryKey: OCCURRENCE_CONDITION_QUERY_KEY,
      query: {
        ...defaultOccurrenceComparatorValues,
      },
    };
  }

  // occurence keys will not exist when reselecting a value in the dropdown, and requires default values
  if (!maybeExistingOccurrence || Object.keys(maybeExistingOccurrence).length === 0) {
    maybeExistingOccurrence = defaultOccurrenceComparatorValues;
  }

  // return existing query condition if not new block or newly selected
  return {
    queryKey: OCCURRENCE_CONDITION_QUERY_KEY,
    query: {
      ...maybeExistingOccurrence,
      ...orQueryClause[OCCURRENCE_CONDITION_QUERY_KEY],
    },
  };
});

export const purchaseCreator = curry((orQueryClause) => {
  let maybeExistingPurchase =
    getConditionClauseByKey(PURCHASE_CONDITION_QUERY_KEY, orQueryClause) ||
    orQueryClause[PURCHASE_CONDITION_QUERY_KEY];

  // no type indicates a new query block, default comparator values for req for ux
  if (!orQueryClause.type) {
    return {
      queryKey: PURCHASE_CONDITION_QUERY_KEY,
      query: {
        ...defaultPurchaseComparatorValues,
      },
    };
  }

  // occurence keys will not exist when reselecting a value in the dropdown, and requires default values
  if (!maybeExistingPurchase || Object.keys(maybeExistingPurchase).length === 0) {
    maybeExistingPurchase = defaultPurchaseComparatorValues;
  }

  // return existing query condition if not new block or newly selected
  return {
    queryKey: PURCHASE_CONDITION_QUERY_KEY,
    query: {
      ...maybeExistingPurchase,
      ...orQueryClause[PURCHASE_CONDITION_QUERY_KEY],
    },
  };
});

export function createEventCondition(type, orQuery) {
  const eventConditions = [];
  const maybeBaseEvent = createByEventType(type, baseEventCreator, orQuery);
  const maybePurchaseEvent = createByPurchaseType(type, purchaseCreator, orQuery);

  if (maybeBaseEvent) {
    eventConditions.push(maybeBaseEvent);
  }

  if (maybePurchaseEvent) {
    eventConditions.push(maybePurchaseEvent);
  }
  return eventConditions;
}

export const guardUpdateDuration = (disableDuration, nextSetDuration) => (currentDuration) => {
  if (!currentDuration) {
    return nextSetDuration;
  }

  return disableDuration ? currentDuration : nextSetDuration;
};
